import React, { useMemo, useState, memo } from 'react'
import injectSheet from 'react-jss'
import styles from './slide.styles'
import Slide from '../../../components/slide/slide.jsx'
import SCForm from './sc-form/sc-form.jsx'
import Heaindg from '../../../components/heading/heading.jsx'
import { SCContext } from './sc-helpers'
import { errorHandler } from 'pobble-components/dist/error-handler'
import {
  withPresentation,
  usePresentation
} from '../../../presentation-connectors'
import { accessibilityColors } from '../../../colors'
import { apiClient } from 'pobble-components/dist/api'

const apiUpdateSlide = (id, data, params) =>
  apiClient.put(`v3/slides/${id}`, data, { params })

const filterCriteria = criteria =>
  criteria.filter(criteria => criteria.criterion)

const SuccessCriteria = memo(({ classes, accessibilityColor, id, slides }) => {
  const { onSlideUpdate } = usePresentation()

  const data = slides[id]

  const slideData = useMemo(
    () => ({
      title: data.title
    }),
    [data]
  )

  const bgColor = useMemo(() => accessibilityColors[accessibilityColor], [
    accessibilityColor
  ])

  const [editMode, setEditMode] = useState(false)
  const [showPrompts, setShowPrompts] = useState(true)
  const [updatingData, setUpdatingData] = useState(false)

  const value = useMemo(
    () => ({
      editMode,
      showPrompts,
      updatingData,
      setEditMode,
      setShowPrompts,
      setUpdatingData,
      onSubmit: values => {
        setUpdatingData(true)
        return apiUpdateSlide(
          id,
          {
            title: values.title,
            criteria: filterCriteria(values.criteria)
          },
          { include: 'slide.type,slide.details' }
        )
          .then(res => {
            onSlideUpdate && onSlideUpdate(res.data.slide)
            setEditMode(false)
            setUpdatingData(false)
          })
          .catch(errorHandler)
      }
    }),
    [
      editMode,
      showPrompts,
      updatingData,
      setEditMode,
      setShowPrompts,
      setUpdatingData,
      id,
      onSlideUpdate
    ]
  )

  return (
    <SCContext.Provider value={value}>
      <Slide className={classes.container}>
        <Heaindg className={classes.title}>{slideData.title}</Heaindg>
        {!!data.criteria && <SCForm id={id} bgColor={bgColor} />}
      </Slide>
    </SCContext.Provider>
  )
})

export default withPresentation(injectSheet(styles)(SuccessCriteria))
